import { toast } from "sonner";
import { Copy } from "lucide-react";

const BASE = `${window.location.origin}/api/partner`;

const UPLOAD = `curl -X POST ${BASE}/products \\
  -H "X-API-Key: YOUR_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "products": [
      {
        "name": "Grand Theft Auto V",
        "platform": "Rockstar",
        "price": 9.99,
        "stock": 100,
        "description": "Optional text shown on the game page",
        "image_url": "https://optional-image-link.jpg"
      }
    ]
  }'`;

const LIST = `curl ${BASE}/products -H "X-API-Key: YOUR_KEY"`;

const PATCH = `curl -X PATCH ${BASE}/products/PRODUCT_ID \\
  -H "X-API-Key: YOUR_KEY" -H "Content-Type: application/json" \\
  -d '{"price": 8.49, "stock": 250}'`;

const Block = ({ title, code, id }) => (
  <div className="space-y-2">
    <div className="flex items-center justify-between">
      <p className="text-sm font-semibold">{title}</p>
      <button data-testid={`partner-docs-copy-${id}`} onClick={() => { navigator.clipboard.writeText(code); toast.success("Copied"); }} className="p-3 sm:p-2 text-gray-400 hover:text-emerald-400"><Copy size={14} /></button>
    </div>
    <pre className="text-xs font-mono bg-[#08090C] border border-white/10 rounded-md p-3 overflow-x-auto">{code}</pre>
  </div>
);

export const PartnerDocs = () => (
  <section data-testid="partner-docs" className="rounded-lg border border-white/10 bg-[#0F1117] p-4 sm:p-6 space-y-5">
    <div>
      <p className="label-eyebrow text-emerald-400">API guide for partners</p>
      <p className="text-sm text-gray-400 mt-2">Send every request with the header <code className="font-mono text-gray-200">X-API-Key</code>. Up to 500 products per upload.</p>
      <ul className="text-xs text-gray-400 mt-3 space-y-1 list-disc pl-5">
        <li><b className="text-gray-200">name, platform, price, stock</b> are required. platform: Steam, Rockstar, Xbox, Epic, PlayStation, Battle.net or Other.</li>
        <li><b className="text-gray-200">stock</b> on upload is the number of codes to add. If the game already exists (same name + platform), stock is added and the price is replaced.</li>
        <li><b className="text-gray-200">description, image_url</b> are optional. Without an image, the official Steam image is found automatically.</li>
        <li>PATCH sets the new total <b className="text-gray-200">stock</b> and/or price, description, image_url for products the partner uploaded.</li>
      </ul>
    </div>
    <Block id="upload" title="Upload products" code={UPLOAD} />
    <Block id="list" title="List my products" code={LIST} />
    <Block id="patch" title="Update price / stock" code={PATCH} />
  </section>
);
